import { Component, ViewChild, ElementRef, OnDestroy, OnInit, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { N3026OutputData } from './n3026-output-data';
import { N3026InputData } from './n3026-input-data';
import { CommonConst, CommonMsgConst, MessageUtil, CommonStorageKey } from '../shared';
import { MessageInfoComponent } from '../shared/component/message-info';
import { ValidationUtil } from '../shared/utility/validation-util';
import { DialogService, DialogComponent } from 'ngx-bootstrap-modal';
import { N302SessionStorageKey } from './n302-session-storage-key';
import { FileUtil } from '../shared/utility/file-util';
import { DialogYesComponent } from '../shared/component/dialog-yes';
import { GaUtil } from '../shared/utility/ga-util';
import { RedirectUtil } from '../shared/utility/redirect-util';
declare var $: any;

@Component({
  selector: 'app-n3026',
  templateUrl: './n3026.component.html',
  styleUrls: ['./n3026.component.css']
})
export class N3026Component extends DialogComponent<null, boolean> implements OnInit, OnDestroy {

  @ViewChild('chohyoKbn') chohyoKbn: ElementRef;
  @ViewChild('shuturyokuKbn_hontai') shuturyokuKbn_hontai: ElementRef;
  @ViewChild('shuturyokuKbn_buzai') shuturyokuKbn_buzai: ElementRef;
  @ViewChild('outputFileEr') outputFileEr: ElementRef;
  elementId: any;

  public inputData = new N3026InputData();
  public outputData = new N3026OutputData();
  public alreadySubmitFlg = false; // ST-359
  constructor(dialogService: DialogService,
    private http: HttpClient,
    private router: Router,
    private messageInfo: MessageInfoComponent) {
    super(dialogService);
  }

  /**
   * 初期表示
   * */
  ngOnInit() {
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245

    // サーバ側の初期処理を呼出す
    document.body.style.cursor = 'wait';
    let inputData: N3026InputData = new N3026InputData();
    inputData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post('/InitialN3026', inputData).subscribe(result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        this.close();
        return;
      }
    }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }), () => { document.body.style.cursor = 'default'; }); // 強化テストNo146

    // コンボボックスの初期値を設定する
    this.inputData.chohyoKbn = "";
    // 初期フォーカスを設定する
    this.chohyoKbn.nativeElement.focus();
  }

  /**
   * 帳票出力
   * */
  outputFile() {
    // ST-359 start
    if (this.alreadySubmitFlg) {
      return;
    }
    // ST-359 end
    // エラーメッセージをクリアする。
    this.messageInfo.clearMsg();
    // エラー項目の背景色をクリアする
    ValidationUtil.ClearBackgroundColor('chohyoKbn');

    let msgList: Array<string> = new Array<string>();
    this.messageInfo.setMsgListNoTopScroll(msgList); // ST-366

    // 帳票一覧 必須
    msgList = ValidationUtil.isRequiredWithColor('chohyoKbn', this.inputData.chohyoKbn, msgList, '帳票一覧');

    if (msgList != null && msgList.length > 0) {
      this.dialogService.addDialog(DialogYesComponent, { message: msgList, elementId: 'chohyoKbn' }
      ).subscribe((isOk) => {
        
      });
      // 処理終了
      return;
    }
    this.alreadySubmitFlg = true;
    // 配送時間個別仮登録画面のセッションストレージから検索用条件を取得する
    // 日付
    this.inputData.hizukeKubun = sessionStorage.getItem(N302SessionStorageKey.N3021HIDUKEKUBUN);
    // 日付From
    var hidukeStart = sessionStorage.getItem(N302SessionStorageKey.N3021HIDUKESTART);
    this.inputData.hizukeStart = hidukeStart.replace(/\//g, '');
    // 日付To
    var hizukeEnd = sessionStorage.getItem(N302SessionStorageKey.N3021HIDUKEEND);
    this.inputData.hizukeEnd = hizukeEnd.replace(/\//g, '');
    // ニチハ営業所
    this.inputData.nichihaEigyosho = sessionStorage.getItem(N302SessionStorageKey.N3021NICHIHAEIGYOSHO);
    // 受注番号
    this.inputData.jyutyuBango = sessionStorage.getItem(N302SessionStorageKey.N3021JYUTYUBANGO);
    // 宛名
    this.inputData.atena = sessionStorage.getItem(N302SessionStorageKey.N3021ATENA);
    // お客様注文No.
    this.inputData.okyauksamaTyumonNo = sessionStorage.getItem(N302SessionStorageKey.N3021OKYAUKSAMATYUMONNO);
    // 配送形態
    this.inputData.haisouKeitai = sessionStorage.getItem(N302SessionStorageKey.N3021HAISOKEITAI);
    this.inputData.haisouKeitai1 = sessionStorage.getItem(N302SessionStorageKey.N3021HAISOKEITAI1);
    this.inputData.haisouKeitai2 = sessionStorage.getItem(N302SessionStorageKey.N3021HAISOKEITAI2);
    this.inputData.haisouKeitai3 = sessionStorage.getItem(N302SessionStorageKey.N3021HAISOKEITAI3);
    // 品番
    this.inputData.hinban = sessionStorage.getItem(N302SessionStorageKey.N3021HINBAN);
    // 建築会社様名
    this.inputData.kenchikuKaisyaSamaMei = sessionStorage.getItem(N302SessionStorageKey.N3021KENCHIKUKAISYASAMAMEI);
    // 登録状況
    this.inputData.tourokuJokyo  = sessionStorage.getItem(N302SessionStorageKey.N3021TOUROKUJOKYO);
    this.inputData.tourokuJokyo1 = sessionStorage.getItem(N302SessionStorageKey.N3021TOUROKUJOKYO1);
    this.inputData.tourokuJokyo2 = sessionStorage.getItem(N302SessionStorageKey.N3021TOUROKUJOKYO2);
    this.inputData.tourokuJokyo3 = sessionStorage.getItem(N302SessionStorageKey.N3021TOUROKUJOKYO3);
    // 物件名
    this.inputData.bukenMei = sessionStorage.getItem(N302SessionStorageKey.N3021BUKENMEI);
    // 配送ルート
    this.inputData.haisoRuto = sessionStorage.getItem(N302SessionStorageKey.N3021HAISORUTO);
    // 出荷用備考
    this.inputData.syukayoBiko = sessionStorage.getItem(N302SessionStorageKey.N3021SYUKAYOBIKO);
    // 車番
    this.inputData.syaban = sessionStorage.getItem(N302SessionStorageKey.N3021SYABAN);
    // 注文方法
    this.inputData.chumonHoho1 = sessionStorage.getItem(N302SessionStorageKey.N3021CHUMONHOHO1);
    this.inputData.chumonHoho2 = sessionStorage.getItem(N302SessionStorageKey.N3021CHUMONHOHO2);
    // 並び順
    this.inputData.narabiJyun = sessionStorage.getItem(N302SessionStorageKey.N3021NARABIJYUN);
    // 過去５営業日
    var kakoEigyoubi5 = sessionStorage.getItem(N302SessionStorageKey.N3021KAKOEIGYOUBI5);
    this.inputData.kakoEigyoubi5 = kakoEigyoubi5.replace(/\//g, '');
    // FROMの１０営業日前
    var kakoEigyoubi10 = sessionStorage.getItem(N302SessionStorageKey.N3021KAKOEIGYOUBI10);
    this.inputData.kakoEigyoubi10 = kakoEigyoubi10.replace(/\//g, '');

    // 選択された帳票を出力する
    // 帳票出力(N3026)のコントローラ処理を呼出す
    document.body.style.cursor = 'wait';
    this.inputData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post<N3026OutputData>('/PrintN3026', this.inputData).subscribe(result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        return;
      }
      this.outputData = result[0];
      if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_OK) {
        // 出力されたファイルをダウンロードする
        let fileName = this.outputData.fileName;
        FileUtil.fileDownload(this.http, fileName, "", this.outputData.downLoadFileName); // ST-361
          
      } else if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_COUNT_ZERO) {
        msgList.push(MessageUtil.getStorageMessage('N999102')); // 課題No18
        this.dialogService.addDialog(DialogYesComponent, { message: msgList }
        ).subscribe((isOk) => {
          // フォーカスを設定する
          this.chohyoKbn.nativeElement.focus();
        });
      } else {
        this.close(false);
        this.router.navigateByUrl('/ne01', { skipLocationChange: true }); // 強化テストNo146
      }
      this.alreadySubmitFlg = false; // ST-359
      document.body.style.cursor = 'default';
    }, error => { this.close(false); this.router.navigateByUrl('/ne01', { skipLocationChange: true }); }); // 強化テストNo146

    GaUtil.traceEvent_EachGroupCd('配送時間個別仮登録 出力（その他帳票）', '');
  }

  ngOnDestroy() {
    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245

    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Tabキーおよび十字キーの場合
    if ((event.keyCode == 9 && !event.shiftKey) || event.keyCode == 39 || event.keyCode == 40) { // 強化テストNo280
      if (document.activeElement.id == 'chohyoKbn') {
        this.shuturyokuKbn_hontai.nativeElement.focus();
      } else if (document.activeElement.id == 'shuturyokuKbn_hontai') {
        this.shuturyokuKbn_buzai.nativeElement.focus();
      } else if (document.activeElement.id == 'shuturyokuKbn_buzai') {
        this.outputFileEr.nativeElement.focus();
      } else {
        this.chohyoKbn.nativeElement.focus();
      }
      return false;
    }
    // 十字キーの場合
    if ((event.keyCode == 37 || event.keyCode == 38) || (event.keyCode == 9 && event.shiftKey)) {　// 強化テストNo280
      if (document.activeElement.id == 'outputFileEr') {
        this.shuturyokuKbn_buzai.nativeElement.focus();
      } else if (document.activeElement.id == 'shuturyokuKbn_buzai') {
        this.shuturyokuKbn_hontai.nativeElement.focus();
      } else if (document.activeElement.id == 'shuturyokuKbn_hontai') {
        this.chohyoKbn.nativeElement.focus();
      } else {
        this.outputFileEr.nativeElement.focus();
      }
      return false;
    }
    // Enterキーの場合
    if (event.keyCode == 13) {
      if (document.activeElement.id == 'outputFileEr' || document.activeElement.id == 'chohyoKbn') {
        return true;
      }
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/n302/n3026.component.ts